import { render } from "./AdminRooms.vue?vue&type=template&id=0b7cff1e&scoped=true"
import script from "./AdminRooms.vue?vue&type=script&lang=js"
export * from "./AdminRooms.vue?vue&type=script&lang=js"

import "./AdminRooms.vue?vue&type=style&index=0&id=0b7cff1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7cff1e"]])

export default __exports__